
import { Amplify } from 'aws-amplify';
import { IAuthInterface } from '../../services/interface/user/login/IAuthInterface';
import ConfigService from 'src/services/config/config.service';
import React from 'react';
import { signUp, confirmSignUp, resetPassword, resendSignUpCode, confirmResetPassword } from '@aws-amplify/auth';

Amplify.configure({
	Auth: {
		Cognito: {
			userPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId,
			userPoolClientId: ConfigService.getConfig().awsConfig.userPoolWebClientId,
			identityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId,
		}
	}
});

export const DefaultAuthContextState: IAuthInterface = {
	signUp: async (email: string, password: string) => {
		const lowerCaseEmail = email.toLowerCase();
		return signUp({
			password,
			username: lowerCaseEmail,
			options: {
				userAttributes: {
					email: email.toLowerCase().trim(),
				},
			},
		});
	},

	confirmSignUp: async (email: string, code: string) => {
		return new Promise<any>(async (res, reject) => {
			try {
				res(await confirmSignUp({ username: email.toLowerCase(), confirmationCode: code }));
			} catch (e) {
				if (e.code === 'UnexpectedLambdaException' || e.code === 'NotAuthorizedException') {
					res(true);
				} else {
					reject(e);
				}
			}
		});
	},

	signIn: async (email: string, password: string) => {
		throw new Error("Not implemented")
	},

	signInWithMFA: async (email: string, password: string, mfaCode: string) => {
		throw new Error("Not implemented")
	},

	signOut: async () => {
		throw new Error("Not implemented")
	},

	requestEmailConfirmation: async (email: string) => {
		return resendSignUpCode({ username: email.toLowerCase().trim() });
	},

	forgotPassword: async (email: string) => {
		return resetPassword({ username: email.toLowerCase().trim() });
	},

	forgotPasswordSubmit: async (email: string, code: string, newPassword: string) => {
		return confirmResetPassword({
			username: email.toLowerCase().trim(),
			confirmationCode: code,
			newPassword
		});
	},

	completeNewPassword: async (user: any, newPass: string) => {
		return null;
	},

	isLoggedIn: () => false,
	hasCurentUser: () => false,

	currentEmail: undefined,
	currentUser: undefined
};

export const AuthContext = React.createContext<IAuthInterface>(DefaultAuthContextState);
